import React, { Fragment } from 'react';
import { useLoadingText } from '../../locale/I18nContext';
import { Pane } from '../Pane';
import { BusyStateIndicator } from '@sas/nova-commons/components/BusyStateIndicator';
import { useLoadingBusyTokens, useLoadingThemeContext } from './ReportThemeContainer';
import { ThemeProvider } from '@sas/nova-commons/theme';
// TODO: move this into a SASReport folder
export const LoadingText = () => {
    var _a, _b;
    const loadingText = useLoadingText();
    const [theme, style] = useLoadingThemeContext();
    const [busyAnimationTokens, busyTokens] = useLoadingBusyTokens();
    return (React.createElement(ThemeProvider, { currentTheme: theme },
        React.createElement(Fragment, null,
            React.createElement("span", { style: {
                    visibility: 'hidden',
                    position: 'absolute',
                    fontFamily: (_a = style === null || style === void 0 ? void 0 : style.fontFamily) !== null && _a !== void 0 ? _a : '"AvenirNext"',
                } }, "Mg"),
            React.createElement("span", { style: {
                    visibility: 'hidden',
                    position: 'absolute',
                    fontFamily: (_b = style === null || style === void 0 ? void 0 : style.fontFamily) !== null && _b !== void 0 ? _b : '"AvenirNext"',
                    fontWeight: 'bold',
                } }, "Mg"),
            React.createElement(Pane, { style: {
                    display: 'flex',
                    flexShrink: 1,
                    flexDirection: 'column',
                    height: '100%',
                    justifyContent: 'center',
                    backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
                    fontFamily: style === null || style === void 0 ? void 0 : style.fontFamily,
                } },
                React.createElement(BusyStateIndicator, { tokens: busyTokens, animationTokens: busyAnimationTokens, active: true, text: loadingText, delay: 0 })))));
};
